<template>
  <div class="m-6 columns">
    <div class="column is-3 box m-0 mr-5">
      <p class="p-3">Choose job title:</p>
      <BaseDropdown
        :leftOffset="-10"
        wrapperClasses="p-3"
        dialogClass="p-0"
        :onDialogChange="chooseJobTitle">
        <template v-slot:toggle-button="{ handleToggle }">
          <div @click="handleToggle" class="pick-job-title-container">{{ selectedJobTitle ? selectedJobTitle.name : '... בחר/י' }}</div>
        </template>
        <div class="container py-3 px-2 max-width-dropdown">
          <input type="search" class="input" v-model="searchJobTitle" />
          <label v-for="jobTitle in dropdownJobTitles" :key="jobTitle.id">
            <input type="checkbox" name="skills" :value="jobTitle.id" hidden />
            <p class="search_result has-text-right">{{ jobTitle.name }}</p>
          </label>
        </div>
      </BaseDropdown>
    </div>
    <div class="column box">
      <div v-if="selectedJobTitle">
        <div class="is-flex is-align-items-center mb-5">
          <p class="p-3 mr-4">Job title skills:</p>
          <BaseDropdown
            :leftOffset="-10"
            wrapperClasses="p-3"
            dialogClass="p-0"
            :onDialogChange="createJobTitleSkill">
            <template v-slot:toggle-button="{ handleToggle }">
              <button class="button is-info small" @click="handleToggle">+ Add skill</button>
            </template>
            <div class="container py-3 px-2 max-width-dropdown">
              <input type="search" class="input" v-model="searchJobTitleSkills" />
              <label v-for="skill in dropdownSkills" :key="skill.id">
                <input type="checkbox" name="skills" :value="skill.id" hidden />
                <p class="search_result has-text-right">{{ skill.name }}</p>
              </label>
            </div>
          </BaseDropdown>
        </div>
        <table class="table table is-striped">
          <thead>
            <tr class="is-uppercase has-text-weight-bold">
              <th class="is-clickable" v-for="column in columns" :key="column.key" @click="sortTable(column.key)">
                {{ column.label }}
                <span v-if="sortKey === column.key">
                  <span v-if="sortOrder === 1">⬆️</span>
                  <span v-else>⬇️</span>
                </span>
              </th>
              <td class="has-text-centered">Action</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="skill in jobTitleSkills" :key="skill.id">
              <th style="text-transform: none;">{{ skill.name }}</th>
              <th style="text-transform: none;">{{ skill.question_text }}</th>
              <th style="text-transform: none;">{{ skill.category }}</th>
              <th style="text-transform: none;">{{ skill.priority }}</th>
              <th style="width: 140px;">
                <button class="button is-info is-small px-3 mx-4" @click="updateJobTitleSKill(skill)">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="create-note" class="icon glyph" fill="currentColor">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path d="M20.71,3.29a2.91,2.91,0,0,0-2.2-.84,3.25,3.25,0,0,0-2.17,1L9.46,10.29s0,0,0,0a.62.62,0,0,0-.11.17,1,1,0,0,0-.1.18l0,0L8,14.72A1,1,0,0,0,9,16a.9.9,0,0,0,.28,0l4-1.17,0,0,.18-.1a.62.62,0,0,0,.17-.11l0,0,6.87-6.88a3.25,3.25,0,0,0,1-2.17A2.91,2.91,0,0,0,20.71,3.29Z"></path>
                      <path d="M20,22H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2h8a1,1,0,0,1,0,2H4V20H20V12a1,1,0,0,1,2,0v8A2,2,0,0,1,20,22Z"></path>
                    </g>
                  </svg>
                </button>
                <button class="button is-danger is-small" @click="deleteJobTitleSkill(skill)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 20 20">
                    <g xmlns="http://www.w3.org/2000/svg" id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Dribbble-Light-Preview" transform="translate(-179.000000, -360.000000)" fill="#ffffff">
                        <g id="icons" transform="translate(56.000000, 160.000000)">
                          <path d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z" id="delete-[#1487]"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </button>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p class="p-3 has-text-centered">
          To see skills please first choose job title
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import BaseDropdown from '@/components/BaseDropdown'

export default {
  name: 'JobTitleSkills',
  components: {
    BaseDropdown
  },
  data () {
    return {
      searchJobTitle: '',
      searchJobTitleSkills: '',
      selectedJobTitle: null,
      jobTitleSkills: [],
      sortKey: '',
      sortOrder: 1,
      columns: [
        { key: 'name', label: 'Name' },
        { key: 'question_text', label: 'Question' },
        { key: 'category', label: 'Category' },
        { key: 'priority', label: 'Priority' }
      ]
    }
  },
  computed: {
    ...mapGetters('jobTitles', ['allJobTitles']),
    ...mapGetters('skills', ['allSkills']),
    dropdownJobTitles () {
      return this.allJobTitles.filter(job => {
        return job.name.includes(this.searchJobTitle)
      })
    },
    jobTitlesSkillsIds () {
      return this.jobTitleSkills.map(skill => skill.id).join(',')
    },
    dropdownSkills () {
      return this.allSkills.filter(skill => {
        return !this.jobTitlesSkillsIds.includes(skill.id) && skill.name.includes(this.searchJobTitleSkills)
      })
    }
  },
  methods: {
    sortTable (column) {
      if (this.sortKey === column) {
        this.sortOrder *= -1 // Toggle sort order
      } else {
        this.sortKey = column
        this.sortOrder = 1
      }
      this.jobTitleSkills.sort((a, b) => {
        let result = 0
        if (a[column] > b[column]) {
          result = 1
        } else if (a[column] < b[column]) {
          result = -1
        }
        return result * this.sortOrder
      })
    },
    chooseJobTitle ({ target: { value: jobTitleId } }, closeModal) {
      this.selectedJobTitle = this.allJobTitles.find(j => j.id == jobTitleId)
      this.getJobTitleSkills(jobTitleId)
      closeModal()
    },
    async getJobTitleSkills (jobTitleId) {
      const result = await this.$network_utils.getJobTitleSkills({ id: jobTitleId })
      this.jobTitleSkills = result
      this.sortTable('name')
    },
    async createJobTitleSkill ({ target: { value, type } }, closeModal) {
      if (type == 'checkbox') {
        await this.$network_utils.postJobTitleSkills({ id: this.selectedJobTitle.id, skill_id: value })
        this.getJobTitleSkills(this.selectedJobTitle.id)
        this.searchJobTitleSkills = ''
        closeModal()
      }
    },
    async deleteJobTitleSkill (jobTitle) {
      await this.$network_utils.deleteJobTitleSkills({ id: this.selectedJobTitle.id, skillId: jobTitle.id })
      this.getJobTitleSkills(this.selectedJobTitle.id)
    },
    updateJobTitleSKill (data) {
      this.create({ designator: 'admin-skills-form-modal', component_name: 'AdminSkillsForm', data, modal_title: data.name })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style scoped>
  .max-width-dropdown {
    max-width: 500px;
    max-height: 500px;
    border: 2px solid rgba(0, 0, 0, 0.3);
    overflow-y: scroll;
  }
  .pick-job-title-container {
    cursor: pointer;
    background: url('/black_down_arrow.svg') no-repeat;
    background-position-y: center;
    background-position-x: 10px;
    background-size: 15px;
    width: 100%;
    display: inline-block;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    text-align: right;
  }
</style>
